module.exports = __webpack_public_path__ + "assets/cluster_map_light.png";